export const ModalStyle = {
  baseStyle: {},
  variants: {
    download: {
      modal: { width: 'fit-content', mt: '100px' },
      modalContent: { margin: '100px 16px 16px 16px', boxShadow: 'none', background: 'transparent' },
    },
    jobIndustry: {
      modal: { width: 'fit-content', mt: '100px' },
      modalContent: {maxWidth: ['60%','60%','40%']},//{ margin: '100px 16px 16px 16px', boxShadow: 'none', background: 'transparent' },
      modalFooter: {width:"100%", display:"flex", justifyContent:"space-between"},
      button: {margin: ['0', '0 16px 0 0']},
    },
    preview: {
      modal: { width: '80vw', mt: '100px' },
      modalContent: { margin: '200px 16px 16px 16px', boxShadow: 'none', background: 'transparent' },
    },
  },
};